<div class="modal-body">
  <div class="content">
    <div class="content__top">
      <h4>
        <span *ngIf="selectedOpt.type === OPTION_TYPE.NEW" translate>company.did.add-verification-data-popup.title.add</span>
        <span *ngIf="selectedOpt.type === OPTION_TYPE.CLONE" translate>company.did.add-verification-data-popup.title.clone</span>
      </h4>
      <button type="button" class="close" aria-label="Close" (click)="close()">
        <i class="icon-small-close"></i>
      </button>
    </div>
    <div class="content__body">
      <ng-container *ngIf="!loading.requirements">
        <gdp-verification-data-selection-form
        [language]="language"
        [country]="did.country"
        [dids]="didsWithVerificationData"
        [requirements]="requirements"
        [allowNoVD]="false"
        (onEmitVerificationData)="onFormChange($event)"
        ></gdp-verification-data-selection-form>
        <div class="vox-inline-message vox-inline-message_light-grey" *ngIf="!isVDRequired">
          <div>
            <i class="icon-small-info"></i>
            <span translate>company.did.add-verification-data-popup.unneeded</span>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="loading.requirements">
        <div class="form-group">
          <ngx-skeleton-loader [theme]="{'height':'24px', 'width': '150px', 'margin-bottom':'6px', 'margin-top':'0px'}"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{'height':'40px', 'margin-top':'-5px'}"></ngx-skeleton-loader>
        </div>
        <div>
          <ngx-skeleton-loader [theme]="{'height':'450px'}"></ngx-skeleton-loader>
        </div>
      </ng-container>
      <div class="submit-container mt-3">
        <button class="vox-btn vox-btn-primary"
          *ngIf="isVDRequired"
          [disabled]="!canSubmit"
          (click)="onSubmit()"
          [ladda]="loading.submit"
          data-spinner-color="white"
          data-style="zoom-in">
          <span *ngIf="selectedOpt.type === OPTION_TYPE.NEW" translate>company.did.add-verification-data-popup.buttons.add</span>
          <span *ngIf="selectedOpt.type === OPTION_TYPE.CLONE" translate>company.did.add-verification-data-popup.buttons.clone</span>
        </button>
      </div>
    </div>
  </div>
</div>
